import React from "react";
import { Modal, Button, Spin } from "antd";
import { BlackXIcon, DeleteInformation } from "../../../../assets/icons";
import "./banner.scss";
import { useTranslation } from "../../../../i18n/LanguageContext";

const DeleteRepresentativeModal = ({ visible, onCancel, onOk, loadingDeleteAllRepresentative }) => {
   const { t } = useTranslation();
   return (
      <Modal
         open={visible}
         onCancel={onCancel}
         onOk={onOk}
         closable={false}
         wrapClassName="delete-organization-modal"
         footer={[
            <div className="footer-buttons-organization">
               <Button
                  className="cencel-organization-delete-button"
                  key="cancel"
                  onClick={onCancel}
               >
                  {t("cancel")}
               </Button>
               <Button className="delete-organization-button" type="primary" danger onClick={onOk}>
                  {loadingDeleteAllRepresentative ? <Spin /> : t("delete-button")}
               </Button>
            </div>
         ]}
      >
         <div>
            <img
               src={BlackXIcon}
               alt="BlackXIcon"
               onClick={onCancel}
               style={{ float: "right", cursor: "pointer" }}
            />
            <div className="delete-organization-modal-content">
               <img src={DeleteInformation} alt="DeleteInformation" />
               <h1 className="delete-organization-title">{t("delete-all-representative-details-title")}</h1>
            </div>
            <p className="delete-organization-description">
               <div>{t("delete-representative-info-description-1")}</div>
               <div>{t("delete-representative-info-description-2")}</div>
               <div>{t("delete-representative-info-description-3")}</div>
               <span>{t("confirm-continue-text")}</span>
            </p>
         </div>
      </Modal>
   );
};

export default DeleteRepresentativeModal;
